import React, { useEffect } from "react";
declare global {
  interface Window {
    TradingView: any;
  }
}

export {};

const TradingViewChart = () => {
  useEffect(() => {
    new window.TradingView.widget({
      container_id: "tradingview_widget",
      autosize: true,
      symbol: "BTCUSDT",
      interval: "D",
      timezone: "Etc/UTC",
      theme: "light",
      style: "1",
      locale: "en",
      enable_publishing: false,
      withdateranges: true,
      hide_side_toolbar: false,
      allow_symbol_change: true,
      studies: ["RSI@tv-basicstudies"],
    });
  }, []);

  return (
    <div
      id="tradingview_widget"
      style={{ height: "480px", borderRadius: "12px" }}
    />
  );
};

export default TradingViewChart;
